import Text, { type TextProps, type TextElementType } from '@ovpn/ui/text';

import { boxed } from '@sso/shared/hocs';

export default boxed<TextProps<TextElementType>, TextElementType>(Text);
